import React from 'react';
import { Route } from 'react-router-dom';

import { RequireAdmin } from '../components/hooks/AuthHook';

import AdminAssignShiftsPage from '../components/admin/AdminAssignShiftsPage';
import LocumlyPage from '../wrappers/LocumlyPage';

function getAdminRoutes() {
  return (
    <Route path={'/admin'} element={<LocumlyPage />}>
      <Route index={true} element={<RequireAdmin><AdminAssignShiftsPage /></RequireAdmin>} />
      <Route path={'shifts/assign'} element={<RequireAdmin><AdminAssignShiftsPage /></RequireAdmin>} />
      <Route path={'*'} element={<RequireAdmin><AdminAssignShiftsPage /></RequireAdmin>} />
    </Route>
  );
}

export default getAdminRoutes;
